import { styled } from '@mui/material'
import { Typography } from 'presentation/components/atoms/typography'

export const StyledTypography = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  cursor: 'default',
}))
